import React from "react";
import { Button, List, Switch, Tag, Typography } from "antd";

const SavedCardsList = ({
  savedCards,
  onEdit,
  onStatusChange,
  isLoading,
  title,
}) => {
  return (
    <div style={{ marginTop: "30px" }}>
      <Typography.Title level={5}>
        {title === "Carousel Banners" ? "" : `${title} Prime Discount Deals`}
      </Typography.Title>

      <List
        itemLayout="horizontal"
        dataSource={savedCards}
        loading={isLoading}
        renderItem={(card, index) => (
          <List.Item
            actions={[
              <Button key="edit" onClick={() => onEdit(card)}>
                Edit
              </Button>,
              <Switch
                onChange={(event) => onStatusChange(card, event)}
                checkedChildren="Visible"
                unCheckedChildren="Hidden"
                checked={card?.isActive}
              />,
            ]}
          >
            <List.Item.Meta
              title={<div>Click Action</div>}
              description={
                <div>
                  {card.clickAction && (
                    <Tag
                      color={card.clickAction === "web-link" ? "purple" : "green"}
                    >
                      {card.clickAction === "web-link"
                        ? "Web Link"
                        : "Service"}
                    </Tag>
                  )}
                  {card.location && (
                    <div style={{ marginTop: "5px", fontSize: "12px", color: "#666" }}>
                      <strong>Location:</strong> {card.location || "N/A"}
                      {card.locationCoordinates && (
                        <span style={{ marginLeft: "10px" }}>
                          ({card?.locationCoordinates?.coordinates[0]?.toFixed(4) || '37.548540'}, {card?.locationCoordinates?.coordinates[1]?.toFixed(4) || "-121.988583"})
                        </span>
                      )}
                    </div>
                  )}
                </div>
              }
              avatar={
                (card.imageUrl || card?.imageUrlWeb) ? (
                  <img
                    src={card.imageUrl || card?.imageUrlWeb}
                    alt="Card"
                    style={{ width: "350px", borderRadius: "5px" }}
                  />
                ) : (
                  <div>No Image</div>
                )
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default SavedCardsList;
